export default __webpack_public_path__ + "static/media/ISKO CLASS-3 EXAM PATTERN 2026-27.47f1d793.pdf";